export const aufgabenColumns = "1fr 1fr 1fr 0.8fr 1.2fr 0.8fr 1.4fr 1.4fr";
